import axios from 'axios';
import { history } from 'ice';
import React, { useContext, useEffect, useState } from 'react';

import commonhelper from '@/lib/commonhelper';
import MobileHomeAccount from '@/pages/_Mobile/components/MobileHomeAccount';
import MobileHomeDraw from '@/pages/_Mobile/components/MobileHomeDraw';
import MobileHomeNotice from '@/pages/_Mobile/components/MobileHomeNotice';

import client from '../../../../lib/feathers';
import { LifeServiceContext } from '../../MobileLayout';
import styles from './MobileHeader.module.scss';

const MobileHeader = (props) => {
  const {
    showBackButton,
    setShowBackButton,
    currentLifeServicePage,
    setCurrentLifeServicePage,
  } = useContext(LifeServiceContext);

  const communityData = client.service('communityData');
  const [headerName, setHeaderName] = useState(null);
  const [community, setCommunity] = useState([]);
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userImg, setUserImg] = useState('');
  const [hasQRcode, setHasQRcode] = useState(false);

  useEffect(() => {
    client
      .reAuthenticate()
      .then((data) => {
        console.log('==re login mobile header ok', data);

        if (
          Object.prototype.hasOwnProperty.call(data.user, 'f_password') &&
          Object.prototype.hasOwnProperty.call(data.user, 'expireTime')
        ) {
          // console.log("yes")
          setHasQRcode(true);
        } else {
          // console.log("no")
          setHasQRcode(false);
        }
        setUserName(data.user.name);
        setUserEmail(data.user.email);
        setUserImg(data.user.img);

        // 20220315 修改MobileHeader遺失問題
        let status = false;
        let arr;

        if (data.user.allow[0].children[0].path.indexOf('/ezpro') >= 0)
          status = true;

        if (status) {
          console.log(status);
          const copyAllow = structuredClone(data.user.allow);
          arr = copyAllow.map((x) => {
            if (x.children) {
              for (let i = 0; i < x.children.length; i++)
                x.children[i].path = x.children[i].path.replace(
                  '/ezpro',
                  '/mobile'
                );
            }
            return x;
          });
        } else {
          arr = data.user.allow;
        }
        if (props.pathname !== '/mobile/home') {
          if (
            ['/mobile/setting', '/mobile/user/person'].includes(props.pathname)
          ) {
            setHeaderName('個人設置');
          }
          if (props.pathname === '/mobile/personalNotice') {
            setHeaderName('個人通知');
          }
          if (props.pathname === '/mobile/noticeRecord') {
            setHeaderName('通知紀錄');
          }
          if (props.pathname === '/mobile/featureGuide') {
            setHeaderName('聯絡我們');
          }
          if (props.pathname === '/mobile/systemSetting') {
            setHeaderName('推播設置');
          } else {
            const allow = arr.find((item) =>
              item.children.find((item) => item.path === props.pathname)
            );
            console.log(allow);
            const headerName = allow.name;
            setHeaderName(headerName);
          }
        }
      })
      .catch((err) => {
        // setHeaderName("登入");
        // if(props.pathname === `mobile/user/login`){
        //   setHeaderName("登入");
        // }
        console.log('==re login mobile header fail', err);
        // const nowRoute = window.location.href.split('#')[1].split('?')[0];
        // console.log(nowRoute);
        // if(!nowRoute.includes('user/login'))history.push('/mobile/user/login');
      });

    communityData
      .find({})
      .then((res) => {
        console.log('==find communityData data success', res.data);
        setCommunity(res.data);
      })
      .catch((err) => {
        console.log('==find communityData data fail', err);
      });
  }, [communityData, props.pathname]);

  return (
    <div
      className={
        history.location.pathname === '/mobile/home'
          ? styles.MobileHeader
          : styles.MobileHeader2
      }
    >
      {history.location.pathname ===
        '/mobile/lifeService/lifeServiceFrontDesk' &&
        showBackButton && (
          <div
            className={styles.backButtonContainer}
            onClick={() => {
              setShowBackButton(false);
              setCurrentLifeServicePage(undefined);
              commonhelper.hidepopup();
            }}
          >
            <img
              className={styles.backButton}
              alt="back button"
              src={`${location.origin}${location.pathname}icon/ic_back button.svg`}
            />
          </div>
        )}
      {/* <img
        className={styles.MobileHeaderBack}
        src="ic_arrow_left.svg"
        alt="Ic_back icon"
      /> */}
      {history.location.pathname === '/mobile/home' ? (
        <div className={styles.MobileHeaderHomeTitle}>
          {community.length > 0 ? community[0].name : ''}
        </div>
      ) : (
        <div className={styles.MobileHeaderTitle}>{headerName}</div>
      )}

      {history.location.pathname === '/mobile/home' ? null : (
        <img
          className={styles.MobileHeaderHome}
          src="icon/ic_home.svg"
          alt="Ic_home icon"
          onClick={async () => {
            if (showBackButton) {
              setShowBackButton(false);
            }
            if (currentLifeServicePage) {
              setCurrentLifeServicePage(undefined);
            }
            client.io.removeListener('elevatorStatus');
            await axios(`/ezcon/api/elevator/status/stopEmit`, {
              method: 'GET',
              headers: { authorization: window.localStorage['feathers-jwt'] },
            });
            // commonhelper.hidepopup();
            history.push('/mobile/home');
          }}
        />
      )}

      {history.location.pathname === '/mobile/home' ? (
        <>
          <MobileHomeDraw />

          <MobileHomeNotice
            setMsgData={(key) => {
              props.setMsgData(key);
            }}
          />

          <MobileHomeAccount
            userName={userName}
            hasQRcode={hasQRcode}
            userEmail={userEmail}
            userImg={userImg}
          />
        </>
      ) : null}
      {/* <div className={styles.MobileHeaderSpace} /> */}
    </div>
  );
};

export default MobileHeader;
